import { render } from "./CommentInput.vue?vue&type=template&id=cbee2f5a&scoped=true"
import script from "./CommentInput.vue?vue&type=script&lang=js"
export * from "./CommentInput.vue?vue&type=script&lang=js"

import "./CommentInput.vue?vue&type=style&index=0&id=cbee2f5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbee2f5a"]])

export default __exports__